// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SkillSquare_mainContainer__280kr","container":"SkillSquare_container__LZ0W0","image":"SkillSquare_image__Db2K6","textContainer":"SkillSquare_textContainer__3kK_M"};